// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Your position`
};

const de_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Position`
};

const es_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Tu posición`
};

const fr_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Votre position`
};

const fi_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Sinun sijoituksesi`
};

const hi_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `आपकी स्थिति`
};

const ja_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `あなたの順位`
};

const nl_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Uw positie`
};

const pt_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Sua posição`
};

const ro_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Poziția ta`
};

const th_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `อันดับของคุณ`
};

const ur_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کی پوزیشن`
};

const zh_hant1_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `您的排名`
};

const da_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Din position`
};

const it_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `La tua posizione`
};

const vn_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Vị trí của bạn`
};

const ko_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `당신의 순위`
};

const tr_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Pozisyonunuz`
};

const lv_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu pozīcija`
};

const ar_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `موقعك`
};

const bs_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša pozicija`
};

const sl_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša pozicija`
};

const id_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Posisi Anda`
};

const sv_widget_leaderboard_your_position = /** @type {(inputs: {}) => string} */ () => {
	return `Din position`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_your_position = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_your_position(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_your_position", locale)
	if (locale === "en") return en_widget_leaderboard_your_position(inputs)
	if (locale === "de") return de_widget_leaderboard_your_position(inputs)
	if (locale === "es") return es_widget_leaderboard_your_position(inputs)
	if (locale === "fr") return fr_widget_leaderboard_your_position(inputs)
	if (locale === "fi") return fi_widget_leaderboard_your_position(inputs)
	if (locale === "hi") return hi_widget_leaderboard_your_position(inputs)
	if (locale === "ja") return ja_widget_leaderboard_your_position(inputs)
	if (locale === "nl") return nl_widget_leaderboard_your_position(inputs)
	if (locale === "pt") return pt_widget_leaderboard_your_position(inputs)
	if (locale === "ro") return ro_widget_leaderboard_your_position(inputs)
	if (locale === "th") return th_widget_leaderboard_your_position(inputs)
	if (locale === "ur") return ur_widget_leaderboard_your_position(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_your_position(inputs)
	if (locale === "da") return da_widget_leaderboard_your_position(inputs)
	if (locale === "it") return it_widget_leaderboard_your_position(inputs)
	if (locale === "vn") return vn_widget_leaderboard_your_position(inputs)
	if (locale === "ko") return ko_widget_leaderboard_your_position(inputs)
	if (locale === "tr") return tr_widget_leaderboard_your_position(inputs)
	if (locale === "lv") return lv_widget_leaderboard_your_position(inputs)
	if (locale === "ar") return ar_widget_leaderboard_your_position(inputs)
	if (locale === "bs") return bs_widget_leaderboard_your_position(inputs)
	if (locale === "sl") return sl_widget_leaderboard_your_position(inputs)
	if (locale === "id") return id_widget_leaderboard_your_position(inputs)
	if (locale === "sv") return sv_widget_leaderboard_your_position(inputs)
	return "widget_leaderboard_your_position"
};